import type { PaymentInstructions } from './types';

/**
 * Bank details are returned once by POST /checkout; GET /orders/:id does not
 * repeat them. Keeping them in sessionStorage lets the order page survive a
 * reload. Per-tab and non-authoritative — the order status is what counts.
 */
const key = (orderId: string) => `payment:${orderId}`;

export function rememberPayment(orderId: string, payment: PaymentInstructions): void {
  try {
    sessionStorage.setItem(key(orderId), JSON.stringify(payment));
  } catch {
    // Private mode or blocked storage: the page falls back to order fields.
  }
}

export function recallPayment(orderId: string): PaymentInstructions | null {
  try {
    const raw = sessionStorage.getItem(key(orderId));
    return raw ? (JSON.parse(raw) as PaymentInstructions) : null;
  } catch {
    return null;
  }
}
